module.exports = __webpack_public_path__ + "img/corporate-mission.99838414.png";